class Footer {
  constructor(parent) {
    if (!parent) {
      return;
    }
    this.parent = parent;
    this.accordion();
  }
  accordion = () => {
    let parent = this.parent;
    if(screen.width < 989) {
      let title = qsa('.footer-accordion-js .footer-item-title-js',parent);
      title.forEach(element => {
        element.addEventListener('click', (e) => {
          let mainParent = e.target.closest('.footer-content-js');
          let activeFaqs = qsa('.footer-accordion-item.active', mainParent);

          let parent = e.target.closest('.footer-accordion-item');
          let target = qs('.footer-content-js', parent);

          if (parent.classList.contains('active')) {
            slideUp(target, 500, () => {
              parent.classList.remove('active');
            });
          } else {
            activeFaqs.forEach((item) => {
              let activeTarget = qs('.footer-content-js', item);
              slideUp(activeTarget, 500, () => {
                item.classList.remove('active');
              });
            })
            slideToggle(target, 500, () => {
              parent.classList.toggle('active');
            });
          }
        })
      });
    }
  }
}

new Footer(qs('.footer-js'))